// extracted by mini-css-extract-plugin
export default {"root":"Sticky_root__azTYc","icon-wrapper":"Sticky_icon-wrapper__6sheA","wave":"Sticky_wave__WQc5P"};